import React from 'react';
import { useHistory } from 'react-router-dom';
import '../dashboard/css/Article1.css';
import blogImage from '../dashboard/assets/Article.avif';
import blog1 from '../dashboard/assets/article6.jpeg';

const Article6 = () => {
  const history = useHistory();

  return (
    <div className="rsh-blog-section">
      {/* Hero */}
      <div
        className="rsh-blog-hero"
        style={{ backgroundImage: `url(${blogImage})` }}
      >
        <div className="rsh-blog-overlay">
          <h1 className="rsh-blog-title">Articles</h1>
          <p className="rsh-breadcrumb">
            <span onClick={() => history.push('/')}>Home</span> / Articles
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="rsh-blog-container">
        <h2 className="rsh-section-title">
          How Online Learning Is Transforming Education in Ahmedabad
        </h2>

        <div className="rsh-published-badge">
          Published on: 06 January 2026
        </div>

        <img
          src={blog1}
          alt="Online Learning in Ahmedabad"
          className="rsh-blog-detail-img"
        />

        <div className="rsh-blog-detail-content">
          <p className="intro-text">
            Online learning is rapidly transforming the education landscape in
            Ahmedabad. With advancements in digital technology and widespread
            internet access, students across the city are embracing online
            education as a flexible, effective, and future-ready learning
            solution.
          </p>

          <p>
            From school students following CBSE, ICSE, and Gujarat Board
            syllabi to college learners and competitive exam aspirants, online
            learning platforms are making quality education more accessible
            than ever before.
          </p>

          {/* SECTION 1 */}
          <div className="info-box">
            <h3>1. Easy Access to Quality Educators</h3>
            <p>
              Online learning eliminates geographical barriers. Students in
              Ahmedabad can now learn from highly qualified teachers and
              subject experts without being restricted to local coaching
              institutes.
            </p>
            <ul>
              <li>Access to experienced national-level educators</li>
              <li>Specialized subject teachers for every grade</li>
              <li>Expert guidance for board and competitive exams</li>
            </ul>
          </div>

          {/* SECTION 2 */}
          <div className="info-box">
            <h3>2. Flexible Learning Schedules</h3>
            <p>
              Online education allows students to plan their study schedules
              around school hours, homework, and extracurricular activities.
            </p>
            <ul>
              <li>Learn anytime from the comfort of home</li>
              <li>Recorded sessions for revision</li>
              <li>Better time management</li>
            </ul>
          </div>

          {/* SECTION 3 */}
          <div className="info-box">
            <h3>3. Personalized and Interactive Learning</h3>
            <p>
              Modern online learning platforms use interactive tools such as
              live classes, digital whiteboards, quizzes, and doubt-solving
              sessions to enhance student engagement.
            </p>
          </div>

          {/* SECTION 4 */}
          <div className="info-box">
            <h3>4. Cost-Effective Education Solution</h3>
            <p>
              Compared to traditional coaching classes, online learning is
              often more affordable. Students save on travel costs, printed
              materials, and infrastructure expenses.
            </p>
          </div>

          {/* TABLE */}
          <h3 className="table-title">
            Online Learning vs Traditional Classroom Learning in Ahmedabad
          </h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Factor</th>
                  <th>Online Learning</th>
                  <th>Traditional Classroom</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Flexibility</td>
                  <td>High</td>
                  <td>Low</td>
                </tr>
                <tr>
                  <td>Access to Teachers</td>
                  <td>Nationwide experts</td>
                  <td>Local teachers only</td>
                </tr>
                <tr>
                  <td>Learning Pace</td>
                  <td>Customized</td>
                  <td>Fixed</td>
                </tr>
                <tr>
                  <td>Cost</td>
                  <td>Affordable</td>
                  <td>Higher overall cost</td>
                </tr>
                <tr>
                  <td>Revision Support</td>
                  <td>Recorded sessions</td>
                  <td>Limited</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* FUTURE */}
          <div className="info-box">
            <h3>5. The Future of Education in Ahmedabad</h3>
            <p>
              With smart classrooms, AI-based learning tools, and digital
              assessments, online education is shaping the future of learning
              in Ahmedabad. Schools and parents are increasingly adopting
              blended learning models that combine online and offline teaching.
            </p>
          </div>

          {/* FINAL */}
          <div className="info-box">
            <h3>Final Thoughts</h3>
            <p>
              Online learning has become an integral part of Ahmedabad’s
              education ecosystem. By offering flexibility, personalized
              learning, and access to expert educators, it is empowering
              students to achieve academic success in a rapidly evolving
              digital world.
            </p>
          </div>

          <div className="rsh-back-btn-wrapper">
            <button
              className="rsh-back-btn"
              onClick={() => history.push('/index')}
            >
              Go Back To Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article6;